import React from "react";
import logoImg from "@/assets/icon_fundobranco.png";

export const Preloader = () => {
  return (
    <div className="fixed inset-0 z-[99999] flex flex-col items-center justify-center bg-slate-950">
      {/* Decorative neon backdrops */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-blue-500/10 rounded-full blur-[60px] pointer-events-none animate-pulse" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-cyan-500/10 rounded-full blur-[40px] pointer-events-none animate-pulse" style={{ animationDelay: "1s" }} />

      <div className="relative flex flex-col items-center">
        {/* Logo and Ring Container */}
        <div className="relative w-[110px] h-[110px] flex items-center justify-center mb-6">
          {/* Animated Spin Ring */}
          <div className="absolute w-[104px] h-[104px] border-2 border-transparent border-t-blue-500 border-r-cyan-400 rounded-full animate-spin" />

          {/* Central Logo Container */}
          <div className="relative w-20 h-20 bg-white rounded-2xl flex items-center justify-center shadow-lg shadow-blue-500/30 overflow-hidden animate-bounce">
            <img src={logoImg} alt="itaCondo Logo" className="w-full h-full object-cover" />
          </div>
        </div>

        {/* Brand Name */}
        <h2 className="mt-2 text-2xl font-bold tracking-tight bg-gradient-to-r from-white to-slate-400 bg-clip-text text-transparent">
          itaCondo
        </h2>

        {/* Subtitle / Loader text */}
        <p className="mt-2 text-xs font-semibold text-slate-500 uppercase tracking-widest animate-pulse">
          Carregando Sistema
        </p>

        {/* Simulated progress bar */}
        <div className="mt-6 w-36 h-1 bg-slate-800 rounded-full overflow-hidden">
          <div className="h-full w-1/3 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-full animate-[loading-bar_1.8s_infinite_ease-in-out]" />
        </div>
      </div>

      <style>{`
        @keyframes loading-bar {
          0% { margin-left: -30%; width: 30%; }
          50% { width: 45%; }
          100% { margin-left: 100%; width: 30%; }
        }
      `}</style>
    </div>
  );
};

export default Preloader;
